import { useState, MouseEvent, MouseEventHandler } from 'react'
import { IconButton, Popover, Typography } from '@mui/material'

import { useStyles } from './styles'
import { ILocationBaseWithId } from 'src/types/locations.type'

interface TableRelationIconProps {
  handleClick?: MouseEventHandler<HTMLButtonElement>
  iconAlt: string
  icon: string
  title?: string
  locationNames?: ILocationBaseWithId[]
  subtitle?: string | null
  isSquared?: boolean
  iconsInARow?: number
  size?: number
  cursor?: string
  resetAvatarMargin?: boolean
  avatarPadding?: string
}

const TableRelationIcon = ({
  handleClick,
  iconAlt,
  icon,
  title,
  subtitle,
  isSquared,
  iconsInARow = 3,
  locationNames,
  size = 30,
  resetAvatarMargin = false,
  cursor = 'pointer',
  avatarPadding,
}: TableRelationIconProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const classes = useStyles({ iconsInARow, resetAvatarMargin, avatarPadding })

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <IconButton
        sx={{ cursor: cursor }}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={handleClick}
        className={isSquared ? classes.selectionButtonSquare : classes.selectionButtonCircle}
      >
        <img
          loading="lazy"
          alt={iconAlt}
          src={icon}
          className={`${classes.selectionIcon} ${isSquared ? '' : classes.selectionIconCircle}`}
          width={size}
          height={size}
          style={{ cursor: cursor }}
        />
      </IconButton>
      <Popover
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        disableScrollLock
      >
        <div className={classes.textWrapper}>
          {title && <Typography className={classes.title}>{title}</Typography>}
          {locationNames &&
            locationNames.length > 0 &&
            locationNames.map(({ id, location_name }) => (
              <Typography key={id} className={classes.locationName}>
                {location_name}
              </Typography>
            ))}
          {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
        </div>
      </Popover>
    </>
  )
}

export { TableRelationIcon }
